import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFlight, getOrderId, getSelectedVskInsurancesByType, getTravellers } from '../../../../Checkout/store/order/selectors';
import { useRefundSummary } from '../../../../RefundSummary';
import { getPassengersSelectedProductIds } from '../../../../RefundSummary/utils';
import { getGdsServicesRefundInfoState, makeGetRefundLoadingByOperation, setGdsServicesRefundInfo, setRefundLoading, getSelectedPassengersStringIds } from '../model';
export const useRefundServicesSummary = () => {
    const dispatch = useDispatch();
    const orderId = useSelector(getOrderId);
    const travellers = useSelector(getTravellers);
    const selectedPassengerIds = useSelector(getSelectedPassengersStringIds);
    const selectedVskInsurances = useSelector(getSelectedVskInsurancesByType);
    const flight = useSelector(getFlight);
    const gdsServicesRefundInfo = useSelector(getGdsServicesRefundInfoState);
    const getServicesLoading = useMemo(() => makeGetRefundLoadingByOperation('services'), []);
    const isLoading = useSelector(getServicesLoading);
    const refundServicesParams = useMemo(() => ({
        orderId,
        passengers: travellers,
        selectedPassengerIds,
        selectedSegmentIds: [],
        allFlightToExchange: true
    }), [orderId, travellers, selectedPassengerIds]);
    const { gdsServicesRefund: queryResult, loading } = useRefundSummary(refundServicesParams);
    const hasProductIdsToRequest = useMemo(() => getPassengersSelectedProductIds(travellers, selectedPassengerIds, [], true).length > 0, [travellers, selectedPassengerIds]);
    useEffect(() => {
        dispatch(setRefundLoading('services', loading));
    }, [dispatch, loading]);
    useEffect(() => {
        var _a, _b;
        if (!hasProductIdsToRequest) {
            dispatch(setGdsServicesRefundInfo(null));
            return;
        }
        // не затираем store во время загрузки
        if (loading) {
            return;
        }
        const nextGdsServicesRefundInfo = (_b = (_a = queryResult === null || queryResult === void 0 ? void 0 : queryResult.GetGdsServicesRefundInfo) === null || _a === void 0 ? void 0 : _a.gdsServicesRefundInfo) !== null && _b !== void 0 ? _b : null;
        dispatch(setGdsServicesRefundInfo(nextGdsServicesRefundInfo));
    }, [dispatch, hasProductIdsToRequest, loading, queryResult]);
    // данные передаем не на прямую из запроса, а через store,
    // т.к. они еще нужны для уведомлений
    // чтобы было синхронное получение данных
    const gdsServicesRefund = useMemo(() => {
        if (!(gdsServicesRefundInfo === null || gdsServicesRefundInfo === void 0 ? void 0 : gdsServicesRefundInfo.length)) {
            return undefined;
        }
        return {
            GetGdsServicesRefundInfo: {
                gdsServicesRefundInfo: gdsServicesRefundInfo
            }
        };
    }, [gdsServicesRefundInfo]);
    const hasServicesToRefund = !!(gdsServicesRefundInfo === null || gdsServicesRefundInfo === void 0 ? void 0 : gdsServicesRefundInfo.length);
    const showRefundSummary = selectedVskInsurances.length > 0 || hasServicesToRefund || hasProductIdsToRequest;
    return {
        showRefundSummary,
        flight,
        travellers,
        gdsServicesRefund,
        insurancesRefund: selectedVskInsurances,
        isLoading
    };
};
